export default __webpack_public_path__ + "static/media/amzn.e0564726.jpg";